import apiClient from '@/services/axios'
import { transformIntoQuery } from '@/utils/pagination'

class ReviewModerationService {
  constructor() {
    this.$api = apiClient
  }

  fetchReviews(pagination, sorting, filter) {
    const query = transformIntoQuery(pagination, sorting, filter)

    return this.$api.get(`/admin/reviews${query}`)
  }

  getReview(reviewId) {
    return this.$api.get(`/admin/reviews/${reviewId}`)
  }

  removeReview(reviewId) {
    return this.$api.delete(`/admin/reviews/${reviewId}`)
  }

  rejectReview(reviewId) {
    return this.$api.patch(`/admin/reviews/${reviewId}/reject`)
  }

  acceptReview(reviewId) {
    return this.$api.patch(`/admin/reviews/${reviewId}/accept`)
  }

  getReviewHistory(reviewId) {
    return this.$api.get(`/admin/reviews/${reviewId}/moderation-log`)
  }

  fetchReplies(pagination, sorting, filter) {
    const query = transformIntoQuery(pagination, sorting, filter)

    return this.$api.get(`/admin/review-replies${query}`)
  }

  removeReply(reviewId) {
    return this.$api.delete(`/admin/review-replies/${reviewId}`)
  }

  rejectReply(reviewId) {
    return this.$api.patch(`/admin/review-replies/${reviewId}/reject`)
  }

  acceptReply(reviewId) {
    return this.$api.patch(`/admin/review-replies/${reviewId}/accept`)
  }

  getReplyHistory(reviewId) {
    return this.$api.get(`/admin/review-replies/${reviewId}/moderation-log`)
  }
}

export default new ReviewModerationService()
